import React from 'react'
import styled from 'styled-components'

const StyledPageContent = styled.div`
  max-width: 90%;
  width: 22rem;
  margin: 5rem auto;
`

const Thankyou = styled.h1`
  font-size: 30px;
  font-family: QuickSand;
  font-weight: 500;
  text-align: center;
`

const SignUpMessageWrapper = styled.div`
  font-weight: 500;
`

const SignUpMessage = styled.p`
  font-weight: 500;
  padding: 0.5rem;
`

const ThankyouForm = () => {
  return (
    <StyledPageContent>
      <Thankyou>Thank you</Thankyou>
      <SignUpMessageWrapper>
        <SignUpMessage>
          Thank you for signing up Ben’s Tailor Online Learning System.
        </SignUpMessage>{' '}
        <SignUpMessage>
          Our staff member will be in touch with you as soon as we can to
          complete the registration process.
        </SignUpMessage>
      </SignUpMessageWrapper>
    </StyledPageContent>
  )
}

export { ThankyouForm }
